import React from "react";
import { useHistory } from "react-router-dom";
import { Hero, SectionCards } from "../../components";
import { eventsData, heroData } from "../../assets/data/eventData";

export default function Event(props) {
	const history = useHistory();

	const newData = eventsData.filter((data) => {
		return history.location.pathname === data.link;
	});

	return (
		<>
			<Hero data={[{ ...heroData[0], heading: newData[0].title }]} />

			<section className="no-p">
				<SectionCards data={newData} />
			</section>
		</>
	);
}
